@if (isWeatherActive() && weather();) {
  <div class="weather-info">
    <img [src]="weather()?.current?.condition?.icon" [alt]="weather()?.current?.condition?.text" />
    <span class="temperature">{{ weather()?.current?.temp_c }}°C</span>
    <span class="condition">{{ weather()?.current?.condition?.text }}</span>
  </div>
}

<span class="status">{{ currentDay() }}</span>
<span class="date">{{ currentDate() }}</span>

@if (showBellIcon()) {
  <div class="hand-bell" (click)="onBellClick()">
    <img [src]="bellIconPath()" alt="Bell Icon" />
  </div>
}
